<template>
        <el-popover>
            <template v-if="!!sections" v-for="key in keys">
                <slot :name="key"></slot>
                <button class="head-button" slot="reference">
                    <font-awesome-icon class="filter-icon" icon="cog"/>
                </button>
            </template>
        </el-popover>
</template>

<script>
    export default {
        props: {sections: Object},
        computed: {
            keys() {
                return Object.keys(this.sections)
            }
        }
    }
</script>

<style scoped>
    .filter-icon {
        font-size: 14px;
    }
</style>